<fusioncharts width="100%" [height]="height" [chartConfig]=chartConfig [dataSource]=dataSource>
</fusioncharts>